import React, { useContext } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import CommonPagination from '../../CommonComponent/CommonPagination/CommonPagination';
import MemberTableConfig from '../../AllMemberComponent/Utilities/MemberTableConfig';
import { MemberRequestContext } from '../MemberRequestComponent';
import Parse from '../../../Utilities/parse';

function MemberRequestTable() {
    const {
        setRejectModal,
        dataForTable,
        setGetSingleMemberData,
        pageConfigurationFromCommonPagination,
        setPageConfigurationFromCommonPagination,
        currentPage,
        setCurrentPage
    } = useContext(MemberRequestContext)
    const columns = MemberTableConfig.requestedMemberColumn({ currentPage, setGetSingleMemberData, setRejectModalShow: setRejectModal })

    return (
        <>
            <BootstrapTable
                wrapperClasses={'table-responsive'}
                headerClasses={"tableTwoHeader"}
                keyField="id"
                data={dataForTable.data || []}
                columns={columns}
            />
            <CommonPagination
                setPageConfigurationFromCommonPagination={setPageConfigurationFromCommonPagination}
                totalPage={Math.ceil((Parse.toNumber(dataForTable.totalRowCount) / 50) || 0)}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />
        </>
    );
}

export default MemberRequestTable;